// @flow
import React, { Component } from "react";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";

export const baseStyles = (theme: DictionaryType): DictionaryType => ({
  labelFormControl: {
    paddingLeft: "30px",
    fontSize: "0.9375rem"
  },
  whiteLabel: {
    color: theme.palette.primary.contrastText,
    "&$labelFocused": {
      color: theme.palette.primary.contrastText
    },
    "&$labelError": {
      color: theme.palette.error.main
    },
    "&$labelDisabled": {
      color: theme.palette.grey.main
    }
  },
  greenLabel: {
    color: theme.palette.primary.light,
    "&$labelFocused": {
      color: theme.palette.primary.main
    },
    "&$labelError": {
      color: theme.palette.error.main
    },
    "&$labelDisabled": {
      color: theme.palette.grey.main
    }
  },
  labelFocused: {},
  labelError: {},
  labelDisabled: {},
  inputFont: {
    fontSize: "0.9375rem",
    paddingLeft: "20px"
  },
  inputRootWhite: {
    color: theme.palette.primary.contrastText,
    "&$inputDisabled": {
      color: theme.palette.grey.main
    },
    "&$inputError": {
      "&:after": {
        borderBottomColor: theme.palette.error.main
      }
    }
  },
  inputRootGreen: {
    color: theme.palette.common.black,
    "&$inputDisabled": {
      color: theme.palette.grey.main
    },
    "&$inputError": {
      "&:after": {
        borderBottomColor: theme.palette.error.main
      }
    }
  },
  inputDisabled: {},
  inputError: {},
  underlineGreen: {
    "&:before": {
      borderBottomColor: theme.palette.primary.light
    },
    "&:hover:before": {
      borderBottomColor: theme.palette.grey.main + " !IMPORTANT"
    },
    "&:after": {
      borderBottomColor: theme.palette.primary.main
    }
  },
  underlineWhite: {
    "&:before": {
      borderBottomColor: theme.palette.primary.contrastText
    },
    "&:hover:before": {
      borderBottomColor: theme.palette.grey.main + " !IMPORTANT"
    },
    "&:after": {
      borderBottomColor: theme.palette.primary.contrastText
    }
  },
  helper: {
    paddingLeft: "20px"
  }
});

export type SingleTextFieldClassesType = {
  labelFormControl: DictionaryType,
  whiteLabel: DictionaryType,
  greenLabel: DictionaryType,
  labelFocused: DictionaryType,
  labelError: DictionaryType,
  labelDisabled: DictionaryType,
  inputFont: DictionaryType,
  inputRootWhite: DictionaryType,
  inputRootGreen: DictionaryType,
  underlineGreen: DictionaryType,
  underlineWhite: DictionaryType,
  helper: DictionaryType,
  inputError: DictionaryType,
  inputDisabled: DictionaryType
};

type SingleTextFieldPropsType = {
  label: string,
  name: string,
  value: string,
  inpuType: string,
  onChange: Function,
  classes: SingleTextFieldClassesType,
  className?: string,
  isRequired?: boolean,
  isInvalid?: boolean,
  isAutoFocus?: boolean,
  isDisabled?: boolean,
  onBlur?: Function,
  onFocus?: Function,
  onEnter?: Function,
  endAdornment?: React$Element<*>,
  helper?: string,
  isDarkTheme?: boolean
};

class SingleTextField extends Component<SingleTextFieldPropsType, {}> {
  render(): React$Element<*> {
    const classes = this.props.classes;

    return (
      <FormControl fullWidth={true} disabled={this.props.isDisabled}>
        {this.props.label !== "" && (
          <InputLabel
            htmlFor={this.props.name}
            required={this.props.isRequired}
            error={this.props.isInvalid}
            classes={{
              root: this.props.isDarkTheme
                ? classes.whiteLabel
                : classes.greenLabel,
              formControl: classes.labelFormControl,
              focused: classes.labelFocused,
              error: classes.labelError,
              disabled: classes.labelDisabled
            }}
          >
            {this.props.label}
          </InputLabel>
        )}
        <Input
          id={this.props.name}
          name={this.props.name}
          value={this.props.value}
          className={this.props.className}
          classes={{
            root: this.props.isDarkTheme
              ? classes.inputRootWhite
              : classes.inputRootGreen,
            input: classes.inputFont,
            underline: this.props.isDarkTheme
              ? classes.underlineWhite
              : classes.underlineGreen,
            error: classes.inputError,
            disabled: classes.inputDisabled
          }}
          error={this.props.isInvalid}
          onChange={this.props.onChange}
          onBlur={this.props.onBlur}
          onFocus={this.props.onFocus}
          type={this.props.inpuType}
          fullWidth={true}
          inputProps={{
            required: this.props.isRequired
          }}
          autoFocus={this.props.isAutoFocus}
          onKeyPress={(ev: SyntheticKeyboardEvent<*>) => {
            if (this.props.onEnter) {
              if (ev.key === "Enter") {
                this.props.onEnter();
                ev.preventDefault();
              }
            }
          }}
          endAdornment={this.props.endAdornment}
          disabled={this.props.isDisabled}
        />
        {this.props.helper && (
          <FormHelperText
            error={this.props.isInvalid}
            classes={{
              root: classes.helper
            }}
          >
            {this.props.helper}
          </FormHelperText>
        )}
      </FormControl>
    );
  }
}

export default withStyles(baseStyles)(SingleTextField);
